<footer class="text-lg-start">
  <div *ngIf="showTopFooter" class="top-footer">
    <!-- Grid container -->
    <div class=" container p-4">
      <!--Grid row-->
      <div class="row">

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <h5 class="text-uppercase">Footer Content</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Lorem ipsum</a>
            </li>
            <li>
              <a routerLink="./" class="">Ut facilisis</a>
            </li>
            <li>
              <a routerLink="./" class="">Aenean sit</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-lg-0">
          <h5 class="text-uppercase">Footer Content</h5>

          <ul class="list-unstyled mb-0">
            <li>
              <a routerLink="./" class="">Suspendisse potenti</a>
            </li>
          </ul>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
          <h5 class="text-uppercase">Footer Content</h5>

          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iste atque ea quis
            molestias. Fugiat pariatur maxime quis culpa corporis vitae repudiandae aliquam
            voluptatem veniam, est atque cumque eum delectus sint!
          </p>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </div>
  </div>
  <!-- Grid container -->

  <!-- Copyright -->
  <div class="bottom-footer p-4 text-white bg-dark">
    <div class="container">
      <div class="row text-center text-md-start">

        <!-- Columna 1: Información de contacto -->
        <div class="col-md-6 mb-3 mb-md-0">
          <p class="mb-1">
            <strong>Dirección:</strong><br>
            Planta Baja, Av Camacho entre calle Loayza y Bueno N°1471
          </p>
          <p class="mb-1">
            <strong>Teléfono:</strong><br>
            (2)2184444 int. 240
          </p>
          <p class="mb-1">
            <strong>Correo electrónico:</strong><br>
            <a href="mailto:contacto@observatorioagro.gob.bo" class="text-white">contacto&#64;observatorioagro.gob.bo</a>
          </p>
          <p class="mb-0">
            © Copyright 2026, Todos los derechos reservados OAP
          </p>
        </div>

        <!-- Columna 2: Google Maps -->
        <div class="col-md-6">
          <div class="map-responsive">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3826.112516929804!2d-68.12234568460399!3d-16.5035020280771!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x915f208dbbf9f171%3A0x5f74f827f91c238e!2sAv.%20Camacho%20N%C2%BA%201471%2C%20La%20Paz%2C%20Bolivia!5e0!3m2!1ses!2sbo!4v1719482494963!5m2!1ses!2sbo"
              width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
        </div>

      </div>

      <!-- Enlaces adicionales -->
      <ul class="footer-info list-unstyled d-flex justify-content-center flex-wrap mt-3 mb-2">
        <li>
          <button class="btn btn-link text-white" type="button" (click)="showCookieSettings()">
            {{ 'footer.link.cookies' | translate }}
          </button>
        </li>
        <li *ngIf="showPrivacyPolicy">
          <a class="btn text-white" routerLink="info/privacy">{{ 'footer.link.privacy-policy' | translate }}</a>
        </li>
        <li *ngIf="showEndUserAgreement">
          <a class="btn text-white" routerLink="info/end-user-agreement">{{ 'footer.link.end-user-agreement' | translate }}</a>
        </li>
        <li *ngIf="showSendFeedback$ | async">
          <a class="btn text-white" routerLink="info/feedback">{{ 'footer.link.feedback' | translate }}</a>
        </li>
      </ul>

      <!-- Soporte COAR -->
      <!-- <div *ngIf="coarLdnEnabled$ | async" class="notify-enabled text-white text-center mt-2">
        <a class="coar-notify-support-route" routerLink="info/coar-notify-support">
          <img class="n-coar" src="assets/images/n-coar.svg" [attr.alt]="'menu.header.image.logo' | translate" />
          {{ 'footer.link.coar-notify-support' | translate }}
        </a>
      </div> -->
    </div>
  </div>



  <!-- Copyright -->
</footer>
